export const ACCOUNT_REVIEW_PENDING = 'pending_review'

const ACCOUNT_REVIEW_AUTH_HINT_KEY = '__KNOV_ACCOUNT_REVIEW_AUTH_HINT__'

type AuthTokens = {
    'access-token'?: string | null
    uid?: string | null
    client?: string | null
}

type ReviewUser = {
    signup_review_status?: string | null
}

export type AccountReviewAuthHint = {
    authSessionKey: string
    state: 'approved' | 'pending_review'
}

type HintRecord = {
    [ACCOUNT_REVIEW_AUTH_HINT_KEY]?: AccountReviewAuthHint
}

export function getAuthSessionKey(tokens: AuthTokens | null | undefined): string | null {
    if (!tokens?.['access-token'] || !tokens.uid || !tokens.client) return null
    return `${tokens.uid}:${tokens.client}`
}

export function rememberAccountReviewAuthHint(
    target: object,
    tokens: AuthTokens | null | undefined,
    user: ReviewUser | null | undefined,
): AccountReviewAuthHint | null {
    const authSessionKey = getAuthSessionKey(tokens)
    if (!authSessionKey || !user?.signup_review_status) return null

    const hint: AccountReviewAuthHint = {
        authSessionKey,
        state:
            user.signup_review_status === ACCOUNT_REVIEW_PENDING
                ? ACCOUNT_REVIEW_PENDING
                : 'approved',
    }
    const hintTarget = target as HintRecord
    hintTarget[ACCOUNT_REVIEW_AUTH_HINT_KEY] = hint
    return hint
}

export function getAccountReviewAuthHint(
    target: object,
    authSessionKey: string | null,
): AccountReviewAuthHint | null {
    const hint = (target as HintRecord)[ACCOUNT_REVIEW_AUTH_HINT_KEY]
    return authSessionKey && hint?.authSessionKey === authSessionKey ? hint : null
}
